import Model from "../Model";

export type ProductExclusivityType = "mine" | "others" | "shared";

export type ProductsCollection = {
  productsAll: Product[];
  productsMine: Product[];
  productsOthers: Product[];
  productsShared: Product[];
};

export type ProductsCatalog = {
  [key: string]: ProductsCollection;
};

export class Product extends Model {
  static type = "products";

  subjectName!: string;
  sectorName!: string;
  categoryName!: string;
  className!: string;
  secondsCount!: number;
  detectionsCount!: number;
  companiesCount!: number;
  productsCount!: number;
  mediaType!: string;
  subjectId!: string;
  iconUrl!: string;
  exclusivityType!: ProductExclusivityType;
  [key: string]: any;

  get name() {
    return this.subjectName;
  }

  get type(): string {
    return Product.type;
  }
}

export function decodeExclusivityType(
  type: string | undefined,
  plural = false
) {
  switch (type) {
    case "mine":
      return plural ? "Esclusivi miei" : "Esclusivo mio";
    case "others":
      return plural ? "Esclusivi concorrenza" : "Esclusivo concorrenza";
    case "shared":
      return plural ? "Comuni" : "Comune";
  }

  return "";
}
